export default __webpack_public_path__ + "static/menstruacion@2x-5cc47f770e0c7d57de6eb5c08039d23e.png";